<template>
  <!-- 认领列表 -->
  <div class="container">
    <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="待认领" name="first">
        <!-- 按钮列表 -->
        <div class="glo_btnList" ref="btnList">
          <div class="glo_btnList_left">
            <el-button class="glo_btnItems glo_bgcMainColor" @click="claimDialog"
              >认领</el-button
            >
            <el-button class="itemBtn" @click="myModel"
            >表格设置</el-button
            >
          </div>
          <queryBtns
            :MoreConditions="MoreConditions"
            @clerBtns="clerBtns"
            @queryBtn_ok="queryBtn_ok"
            @moreParam="moreParam"
          ></queryBtns>
        </div>
        <!-- 查询条件 -->
        <!-- :formData="queryData" -->
        <queryCondition
          ref="queryForm"
          :More="isHaseMore"
          :formConfig="queryCondditionDatas"
        ></queryCondition>
        <!-- 表格 -->
        <div class="glo_Table">
          <el-table
            :height="tableHeigth"
            header-align="center"
            ref="mytable"
            @row-click="rowclick"
            :data="tableData"
            border
            stripe
            :highlight-current-row="true"
            show-summary
            :summary-method="getSummaries"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              fixed="left"
              align="center"
              label="序号"
              type="index"
              width="60"
            ></el-table-column>
            <el-table-column
              fixed="left"
              align="center"
              type="selection"
              width="60"
            ></el-table-column>
            <template v-for="(item, index) in myTableHeard">
              <!-- 某个字段需要单独操作  例如点击可以跳转 -->
              <el-table-column
                v-if="item.field === 'aaaaaaaaaa' && item.isShow"
                :key="index"
                :label="item.name"
                :prop="item.field"
                align="left"
                sortable
                :show-overflow-tooltip="true"
                :min-width="item.width"
                :data-isTotal="item.isTotal"
              >
                <template slot-scope="scope">
                  <div class="linkTabel">
                    {{ scope.row.aaaaaaaaaa }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :key="index"
                :label="item.name"
                :prop="item.field"
                align="center"
                sortable
                :show-overflow-tooltip="true"
                :min-width="item.width"
                :data-isTotal="item.isTotal"
                v-else-if="item && item.isShow"
              ></el-table-column>
            </template>
          </el-table>
        </div>

        <!-- 分页 -->
        <paging
          ref="pags"
          :pageNum="pageStart"
          :total="pageCount"
          :size="pageTotal"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
        ></paging>
      </el-tab-pane>
      <el-tab-pane label="已认领" name="second">
        <!-- 按钮列表 -->
        <div class="glo_btnList" ref="btnList">
          <div class="glo_btnList_left">
            <el-button class="glo_btnItems glo_bgcMainColor" @click="revokeClaim"
            >取消认领</el-button
            >
            <el-button class="glo_btnItems glo_bgcMainColor" @click="claimSrue"
            >认领确认</el-button
            >
          </div>
          <queryBtns
              :MoreConditions="MoreConditions"
              @clerBtns="clerBtns"
              @queryBtn_ok="queryBtn_ok"
              @moreParam="moreParam"
          ></queryBtns>
        </div>
        <!-- 查询条件 -->
        <!-- :formData="queryData" -->
        <queryCondition
            ref="queryForm"
            :More="isHaseMore"
            :formConfig="queryCondditionDatas"
        ></queryCondition>
        <!-- 表格 -->
        <div class="glo_Table">
          <el-table
              :height="tableHeigth"
              header-align="center"
              ref="mytable"
              @row-click="rowclick"
              :data="tableData"
              border
              stripe
              :highlight-current-row="true"
              show-summary
              :summary-method="getSummaries"
              @selection-change="handleSelectionChange"
          >
            <el-table-column
                fixed="left"
                align="center"
                label="序号"
                type="index"
                width="60"
            ></el-table-column>
            <el-table-column
                fixed="left"
                align="center"
                type="selection"
                width="60"
            ></el-table-column>
            <template v-for="(item, index) in myTableHeard">
              <!-- 某个字段需要单独操作  例如点击可以跳转 -->
              <el-table-column
                  v-if="item.field === 'aaaaaaaaaa' && item.isShow"
                  :key="index"
                  :label="item.name"
                  :prop="item.field"
                  align="left"
                  sortable
                  :show-overflow-tooltip="true"
                  :min-width="item.width"
                  :data-isTotal="item.isTotal"
              >
                <template slot-scope="scope">
                  <div class="linkTabel">
                    {{ scope.row.aaaaaaaaaa }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  :key="index"
                  :label="item.name"
                  :prop="item.field"
                  align="center"
                  sortable
                  :show-overflow-tooltip="true"
                  :min-width="item.width"
                  :data-isTotal="item.isTotal"
                  v-else-if="item && item.isShow"
              ></el-table-column>
            </template>
          </el-table>
        </div>

        <!-- 分页 -->
        <paging
            ref="pags"
            :pageNum="pageStart"
            :total="pageCount"
            :size="pageTotal"
            @handleSizeChange="handleSizeChange"
            @handleCurrentChange="handleCurrentChange"
        ></paging>


      </el-tab-pane>
      <el-tab-pane label="认领记录" name="third">
        <!-- 按钮列表 -->
        <div class="glo_btnList" ref="btnList">
          <div class="glo_btnList_left">
            <el-button class="glo_btnItems glo_bgcMainColor" @click="revokeClaimSrue"
            >取消认领确认</el-button
            >
          </div>
          <queryBtns
              :MoreConditions="MoreConditions"
              @clerBtns="clerBtns"
              @queryBtn_ok="queryBtn_ok"
              @moreParam="moreParam"
          ></queryBtns>
        </div>
        <!-- 查询条件 -->
        <!-- :formData="queryData" -->
        <queryCondition
            ref="queryForm"
            :More="isHaseMore"
            :formConfig="queryCondditionDatas"
        ></queryCondition>
        <!-- 表格 -->
        <div class="glo_Table">
          <el-table
              :height="tableHeigth"
              header-align="center"
              ref="mytable"
              @row-click="rowclick"
              :data="tableData"
              border
              stripe
              :highlight-current-row="true"
              show-summary
              :summary-method="getSummaries"
              @selection-change="handleSelectionChange"
          >
            <el-table-column
                fixed="left"
                align="center"
                label="序号"
                type="index"
                width="60"
            ></el-table-column>
            <el-table-column
                fixed="left"
                align="center"
                type="selection"
                width="60"
            ></el-table-column>
            <template v-for="(item, index) in myTableHeard">
              <!-- 某个字段需要单独操作  例如点击可以跳转 -->
              <el-table-column
                  v-if="item.field === 'aaaaaaaaaa' && item.isShow"
                  :key="index"
                  :label="item.name"
                  :prop="item.field"
                  align="left"
                  sortable
                  :show-overflow-tooltip="true"
                  :min-width="item.width"
                  :data-isTotal="item.isTotal"
              >
                <template slot-scope="scope">
                  <div class="linkTabel">
                    {{ scope.row.aaaaaaaaaa }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  :key="index"
                  :label="item.name"
                  :prop="item.field"
                  align="center"
                  sortable
                  :show-overflow-tooltip="true"
                  :min-width="item.width"
                  :data-isTotal="item.isTotal"
                  v-else-if="item && item.isShow"
              ></el-table-column>
            </template>
          </el-table>
        </div>

        <!-- 分页 -->
        <paging
            ref="pags"
            :pageNum="pageStart"
            :total="pageCount"
            :size="pageTotal"
            @handleSizeChange="handleSizeChange"
            @handleCurrentChange="handleCurrentChange"
        ></paging>


      </el-tab-pane>
    </el-tabs>
    <!--        自定义表头           -->
    <sorttable
        :show_sortTableHeard="show_sortTableHeard"
        :allCheck="allCheck"
        :sortName="sortName"
        :tabelHeadeTitle="tabelHeadeTitle"
        :originalTabelHeadeTitle="originalTabelHeadeTitle"
        :selectLength="selectLength"
        @cancelSortHeard="cancelSortHeard"
        @confirmOk="confirmOk"
        @checktab="checktab"
        @checkAll="checkAll"
        @closeDias="closeDias"
      ></sorttable>

    <!-- 导出插件 -->
    <!-- <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      :queryCondditionDatas="queryCondditionDatas"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
    </exportCompoent> -->
    <!--认领 -->
    <el-dialog
        title="认领"
        :visible.sync="isDT"
        width="40%"
        @close="resetForm('confirmForm')"
    >
      <div class="formbox">
        <el-form
            label-position="right"
            label-width="100px"
            :model="confirmForm"
        >
          <el-form-item label="快递单号：" class="jy-form-input">
            <input
                disabled
                readonly
                v-model="confirmForm.courierNumber"
            />
          </el-form-item>
          <el-form-item label="快递公司：" class="jy-form-input">
            <input
                v-model="confirmForm.expressName"
            />
          </el-form-item>
          <el-form-item
              label="会员号："
              class="jy-form-select"
              prop="memberId"
          >
            <el-select
                class="inputs"
                v-model="confirmForm.memberId"
                placeholder="请选择会员"
                clearable
                filterable
                remote
                reserve-keyword
                :remote-method="getMembers"
                value-key="memberId"
                @visible-change="visibleChange($event, 1)"
            >
              <el-option
                  v-for="(item, index) in memberOptions"
                  :label="item.memberNameShow"
                  :value="item.memberId"
                  :key="index"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="件数：" class="jy-form-input">
            <input
                v-model="confirmForm.count"
                readonly
            />
          </el-form-item>
          <el-form-item
              label="仓库："
              class="jy-form-select"
              prop="storageId"
          >
            <el-select
                v-model="confirmForm.storageName"
                placeholder="请选择"
                clearable
                filterable
                @visible-change="visibleChange($event, 5)"
                @change="
                    onSelect(
                      $event,
                      storageOptions,
                      ['storageId', 'storageName'],
                      ['storageId', 'storageName']
                    )
                  "
            >
              <el-option
                  v-for="(item, index) in storageOptions"
                  :key="index"
                  :label="item.storageName"
                  :value="item.storageId"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="comfirmSub">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>
  <script>
import tableList from "@/pages/DynamicList/tableList.js";
//   import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import queryBtns from "@/components/queryBtnsDT.vue";
import queryCondition from "@/components/queryCondition.vue";
import myDialog from "@/components/DialogDT.vue";
import { Message as ElMessage, MessageBox as ElMessageBox } from 'element-ui'
import utils from "@/assets/js/tool";
//   import exportjs from "@/assets/js/Mixins/exportDT.js"; //导出的公共js
import customerModelService from "@/components/customerService/modelIndex.vue";
import { Api } from "@/assets/js/api";
import sorttable from "@/components/sortTemplate.vue";
import tools from "@/assets/js/tool";

export default {
  mixins: [tableList],
  inject: ["reload"],
  components: {
    sorttable,
    //   sorttable,
    paging,
    queryBtns,
    queryCondition,
    myDialog,
    customerModelService,
  },
  data() {
    return {
      sortName: "包裹认领",
      userList: [],

      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "提货指令列表", //导出时默认文件名
        apiName: "/v1/common/query/runPageReport", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd===等待下载完成,bdd===不等待完成
        apiType: "POST", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      pageGroupName: "DynamicListWaitClaimList", //  页面标识
      reportFiledsNumber: "bill_wait_claim_list_v4", // 动态 条件、表头
      pageGroupNameMap: {
        first: "DynamicListWaitClaimList", //
        second: "DynamicListClaimList", //
        third: "DynamicListClaimRecordList" //
      },
      currentItemArr: [],
      dialogType: "",
      showTimers:false,
      dataList: [],
      oneDocuNumber: "",
      customerModelServiceStatus: false,
      mxSearchHeight: 71,
      activeName: "first",
      tabCache: {
        first: {
          queryData: {},
          tableData: [],
          queryCondditionDatas: [],
          tableHeader: []
        },
        second: {
          queryData: {},
          tableData: [],
          queryCondditionDatas: [],
          tableHeader: []
        },
        third: {
          queryData: {},
          tableData: [],
          queryCondditionDatas: [],
          tableHeader: []
        }
      },
      currentTab: 'first',
      ruCangData:{
        arrivalStorageId: "",
        arrivalTime: "",
        entruckId: [],
      },
      commonDocVisible: false,
      storageOptions: [],
      memberOptions: [],
      confirmIntoStorageVisible : false,
      isDT: false, //  确认认领弹出窗状态1
      confirmForm: { //  表单数据
        storageId: "",
        storageName: "",
        expressName:"",
        count: 1,
        memberId: "",
        documentStatus: "",
        documentNumber: "",
      },
      editTitle: '认领',
    };
  },
  mounted() {
    this.getData();
  },
  created() {
  },
  watch: {},
  methods: {

    mxSetHeight(num) {
      this.mxSearchHeight = num + 15;
    },
    handleClick(tab, event) {
      // 保存当前 tab 的状态
      if (this.activeName && this.$refs.queryForm) {
        const currentFormData = this.$refs.queryForm.getFormData ?
            this.$refs.queryForm.getFormData() :
            this.$refs.queryForm.formData;

        if (!this.tabCache) {
          this.tabCache = {
            first: {},
            second: {},
            third: {}
          };
        }

        // 缓存当前 tab 的数据
        this.tabCache[this.activeName] = {
          ...this.tabCache[this.activeName],
          queryData: currentFormData,
          pageStart: this.pageStart
        };
      }

      // 切换 tab
      this.activeName = tab.name;

      let rqNumber = "bill_wait_claim_list_v4";
      if (tab.name === "second") {
        this.mxSearchHeight = this.mxSearchHeight > 86 ? this.mxSearchHeight : 86;
        rqNumber = "bill_has_claim_list_v4";
      }else if(tab.name === "third"){
        this.mxSearchHeight = this.mxSearchHeight > 86 ? this.mxSearchHeight : 86;
        rqNumber = "bill_claim_record_list_v4";
      }

      // 初始化目标 tab
      this.initTableByTab(tab.name, rqNumber);
    },
    // 表格选择事件
    handleSelectionChange(e) {
      this.currentItemArr = e || [];
    },

    // 不能输入负数
    minNum(val) {
      return val < 0 ? 0 : val;
    },

    async visibleChange(val, type){
      if (val) {
        if (type === 1) {
          if(true === val){
            val = "";
          }
          let arrs = [
            {
              conditonKey: "memberId",
              conditonVal: val,
            },
          ];
          utils.getSelectData("member_down_list", 1,arrs).then((res) => {
            this.memberOptions = res.arr;
          });
        } else if (type === 4) {
        } else if (type === 5 || type === 6) {
          utils.getSelectData("storage_choose_list", 1).then((res) => {
            this.storageOptions = res.arr;
          });
        } else if (type === 7) {
        } else if (type === 8) {
        } else if (type === 9) {
        } else if (type === 10) {
        } else if (type === 11) {
        } else if (type === 12) {
        }
      }
    },
    // 表单字段选择器联动
    onSelect(val, arr, type, select) {
      if (type[1]) {
        const obj = utils.jyIDGetContent(arr, select[0], val);
        if (obj) {
          this.confirmForm[type[1]] = obj[select[1]];
        }
      }
      this.confirmForm[type[0]] = val;
    },

    //包裹认领弹窗
    claimDialog(){
      if (this.currentItemArr.length === 1) {
        ({
          documentStatus: this.confirmForm.documentStatus,
          documentNumber: this.confirmForm.documentNumber,
          expressName: this.confirmForm.expressName,
          count: this.confirmForm.count,
          courierNumber: this.confirmForm.courierNumber,
          storageId: this.confirmForm.storageId,
          storageName: this.confirmForm.storageName,
        } = this.currentItemArr[0]);
        this.editTitle = '认领'
        this.isDT = true
      } else {
        this.$message.warning('请勾选一条数据');
      }
    },

    resetForm(formName) { //  公共表单重置事件
      this.$refs[formName].resetFields();
      if (formName === 'confirmForm') {
        this.confirmForm.memberId = "";
        this.confirmForm.storageId= "";
        this.confirmForm.expressName="";
        this.confirmForm.count= 1;
        this.confirmForm.memberId= "";
        this.confirmForm.documentStatus= "";
        this.confirmForm.documentNumber= "";
        this.confirmForm.storageName= "";
      }
      this.isDT = false;
    },
    //认领弹窗确认事件
    comfirmSub() { //  确认
      let parm = {
        documentStatus: this.confirmForm.documentStatus || '',
        documentNumber: this.confirmForm.documentNumber || '',
        storageId: this.confirmForm.storageId || '',
        expressName: this.confirmForm.expressName || '',
        memberId: this.confirmForm.memberId || '',
      }
      let sign = tools.getSign(parm)
      parm.sign = sign
      Api.claim(parm).then((res) => {
        if (res.data.status === 'success') {
          this.$message.success(res.data.message)
          this.isDT = false
          this.getData()
        } else {
          this.$message.error(`${res.data.message}--认领确认API`)
        }
      })
    },
    // 远程搜索会员
    getMembers(e) {
      if (e.length > 0) {
        this.visibleChange(e,1);
      } else {
        this.visibleChange('',1);
      }
    },
    //取消认领
    async revokeClaim(){
      if (this.currentItemArr.length < 1) {
        ElMessage({
          message: "请选择单据",
          type: "error",
        });
        return false;
      }
      const idList = this.currentItemArr.map((item) => {
        let objp = {
          documentNumber: item.documentNumber,
          documentStatus: item.documentStatus,
        };
        return objp;
      });
      let params = {
        billList: idList,
      };
      ElMessageBox.confirm("是否对该单据进行取消认领？", "系统提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(async () => {
            await Api.revokeClaim(params).then((res) => {
              if (res.status === 200) {
                const data = res.data;
                if (utils.jyCheckObjectType(data) === "Object") {
                  ElMessage({
                    message: data.message,
                    type: data.status,
                  });
                  let that = this;
                  setTimeout(() => {
                    that.queryBtn_ok();
                  }, 500);
                }
              }
            });

          })
          .catch(() => {});
    },

    //认领确认
    async claimSrue(){
      if (this.currentItemArr.length < 1) {
        ElMessage({
          message: "请选择单据",
          type: "error",
        });
        return false;
      }
      const idList = this.currentItemArr.map((item) => {
        let objp = {
          documentNumber: item.documentNumber,
          documentStatus: item.documentStatus,
        };
        return objp;
      });
      let params = {
        billList: idList,
      };
      ElMessageBox.confirm("是否对该单据进行认领确认？", "系统提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(async () => {
            await Api.claimSrue(params).then((res) => {
              if (res.status === 200) {
                const data = res.data;
                if (utils.jyCheckObjectType(data) === "Object") {
                  ElMessage({
                    message: data.message,
                    type: data.status,
                  });
                  let that = this;
                  setTimeout(() => {
                    that.queryBtn_ok();
                  }, 500);
                }
              }
            });

          })
          .catch(() => {});
    },
    //取消认领确认
    async revokeClaimSrue(){
      if (this.currentItemArr.length < 1) {
        ElMessage({
          message: "请选择单据",
          type: "error",
        });
        return false;
      }
      const idList = this.currentItemArr.map((item) => {
        let objp = {
          documentNumber: item.documentNumber,
          documentStatus: item.documentStatus,
        };
        return objp;
      });
      let params = {
        billList: idList,
      };
      ElMessageBox.confirm("是否对该单据进行认领确认？", "系统提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(async () => {
            await Api.revokeClaimSrue(params).then((res) => {
              if (res.status === 200) {
                const data = res.data;
                if (utils.jyCheckObjectType(data) === "Object") {
                  ElMessage({
                    message: data.message,
                    type: data.status,
                  });
                  let that = this;
                  setTimeout(() => {
                    that.queryBtn_ok();
                  }, 500);
                }
              }
            });

          })
          .catch(() => {});
    },
  },




};
</script>
  <style scoped lang="scss">
::v-deep .el-date-editor.el-input {
  width: auto !important;
}

.classA {
  display: flex;
}

.glo_dialogForm .diaForm .dialogFormItems {
  height: 30px !important;
  line-height: 30px !important;
  overflow: hidden;
}

.couponBox {
  width: 100%;
  margin-bottom: 20px;
  height: 34px;

  .couponitmeInput {
    width: 100px;
    border: 1px solid #cccccc;
    margin: 0 6px;

    ::v-deep .el-input__inner {
      height: 30px;
      line-height: 30px;
    }
  }

  .couponItemA {
    display: flex;
    align-items: center;
  }
}

.displays {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.rows {
  display: flex;
  width: 100%;
}

.multipleSelect {
  ::v-deep .el-select {
    border: 1px solid #cccccc;
    border-radius: 4px;
  }
}
</style>
  